export const CommonErrorEventsCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Ricerca Eventi In Errore',
    path: '/sistema/eventmanager/ricerca-eventi-in-errore',
  },
];
